import React, { useState } from 'react';
import { CopyText } from '../../../UiKit';
import toast from 'react-hot-toast';
import { merchantDesignationMappingWithLiterals } from '../../../constants/reasons';
import { merchantModel } from '../../../api';
import {
  MERCHANT_EVENTS,
  sendMerchantApiEvents,
} from '../../../helpers/analytics/merchant.analytics';
import { Eye } from 'lucide-react';

function unmaskNumber(orderID, designation, setNumber, setisMask) {
  const queryParams = {
    order_id: orderID,
    designation: merchantDesignationMappingWithLiterals[designation],
  };

  merchantModel
    .getMerchantNumber(queryParams)
    .then((response) => {
      if (!response || response?.isError === true) {
        return toast.error(
          response.message || 'Something went wrong. Please try again later!',
        );
      }

      sendMerchantApiEvents(
        MERCHANT_EVENTS.GET_MERCHANT_NUMBER_SUCCESS,
        orderID,
        designation,
      );
      setisMask(false);
      setNumber(response.phone);
    })
    .catch((err) => {
      toast.error(
        err.message || 'Something went wrong. Please try again later!',
      );

      sendMerchantApiEvents(
        MERCHANT_EVENTS.GET_MERCHANT_NUMBER_FAILURE,
        orderID,
        designation,
      );
    });
}

export const MerchantNumberV1 = (props) => {
  const { phone, designation, calledTo, orderId, userId } = props;
  const [number, setNumber] = useState(phone);
  const [isMask, setisMask] = useState(true);
  return (
    <div className='tw-text-zinc-600 tw-font-regular'>
      {isMask ? (
        <div className='masked tw-flex tw-items-center tw-leading-tight'>
          <CopyText
            dontShowCopyIcon={true}
            title={number}
            orderId={orderId}
            userId={userId}
            masking={false}
            maskingCount={4}
            calledTo={calledTo}
            calledToType={designation}
            maskEverything={true}
          />
          <Eye
            size={16}
            strokeWidth={1.5}
            className='tw-cursor-pointer tw-text-grey-400 hover:tw-text-grey-500 tw-transition-colors tw-ease-in-out tw-duration-200'
            onClick={() =>
              unmaskNumber(orderId, designation, setNumber, setisMask)
            }
            data-dd-action-name='Unmask Merchant Number'
          />
        </div>
      ) : (
        <div>
          <CopyText
            title={number}
            orderId={orderId}
            userId={userId}
            masking={false}
            maskingCount={4}
            calledTo={calledTo}
            calledToType={designation}
            maskEverything={true}
          />
        </div>
      )}
    </div>
  );
};
